import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class SegmentedMembersProvider extends HttpRequest {
  async getMembersBySegmentID (param) {
    this.setHeader(getAuthToken())
    return this.fetch(`/segmentedUsers/${param}`)
  }

  async getOneBySegmentID (param) {
    this.setHeader(getAuthToken())
    return this.fetch(`/segmentedUsers/${param}/one`)
  }
}

export default SegmentedMembersProvider
